import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class FotoMagistradoService extends Service {
    async recuperarFoto(cpf) {
        return this.getFotoMagistradoApi().recuperar(cpf);
    }
}

export default FotoMagistradoService;
